import React, { Fragment, useState, useEffect } from "react";

import OwlCarousel from 'react-owl-carousel';
import { apiData } from "../../../../actions";
import { useSelector } from "react-redux";
import DataLoader from "../../../../Utils/DataLoader";

function FamilyAttraction() {
  const place = useSelector(state => state.place);
  const [loader, setLoader] = useState(false);

  var settings = {
    items: 4,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      992: {
        items: 4
      }
    }
  };

  const [familyAttractionData, setFamilyAttractionData] = useState("");
  const GetFamilyAttraction = async () => {
    setLoader(true);
    let payload = {
      city: place,
    };
    let apiRes = await apiData.getFamilyAttraction(payload);
    setFamilyAttractionData(apiRes?.data?.familytopattr?.businesses);
    setLoader(false);
  };
  useEffect(() => {
    GetFamilyAttraction();
  }, [place]);
  
  const getUserEmail = () => {
        try {
          const rawUser = localStorage.getItem('userEmail');
          const user = JSON.parse(rawUser); 
          return user?.email || '';
        } catch (error) {
          const rawUser = localStorage.getItem('userEmail');
          if (rawUser && typeof rawUser === 'string' && rawUser.includes('@')) {
            return rawUser; 
          }
          return ''; 
        }
      };
      
      // Usage
      const userEmail = getUserEmail();
      const handleClicks = () => {
        handleSubmit(); 
      };
      const [formData, setFormData] = useState({
          email: '',
          city: '',
          travelerType: '',
        });

      const handleSubmit = async () => {
        const email = userEmail 
        if (!email) {
          console.log('Please log in to continue.');
          return;
        }
        const {city, travelerType } = formData;
        
        
            const finalCity = place || city;
        // Construct the URL dynamically
        const url = `https://backend.mysittivacations.com/api/user-subscription?email=${encodeURIComponent(email)}&firstName=${encodeURIComponent(email.split('@')[0])}&city=${encodeURIComponent(finalCity)}&travelerType=${encodeURIComponent(travelerType)}`;
      
        try {
          const response = await fetch(url, {
            method: 'GET',
          });
      
          if (response.ok) {
            const data = await response.json();
            console.log(data.message); 
            // setFormData({ email: '', city: '', travelerType: '' });
            // setSpecificModal(false);
          } else {
            const error = await response.json();
            console.log(error.message || 'Submission failed'); 
          }
        } catch (error) {
          console.log(error.message || 'Failed to submit form');
        }
      };

  return (
    <Fragment>
      {
        !loader ?
          <div className="flight-sec exitment-sec new1">
            <div className="slider-sec">
              <h3>{`Family Top Attractions in ${place?.replace(/\b\w/g, x => x?.toUpperCase())}`}</h3>
              {familyAttractionData && familyAttractionData.length > 0 ? (
                <OwlCarousel {...settings}>
                  {familyAttractionData.map((ele, index) => (
                    <div key={ele.id || index}  className="slider-block">
                      <div className="slider-block">
                        <a href={ele.url} onClick={handleClicks} target="_blank" rel="noreferrer">
                          <img loading="lazy" src={ele.image_url} alt="" />
                        <div className="slider-content">
                          <h3>{ele?.name.length >= 18 ? `${ele.name.slice(0, 18)}...` : ele?.name}</h3>
                        </div>
                        <div className="escape-room">
                          <p className="time-formate">
                            <img src="/images/location.svg" alt="location"/>
                            {ele?.location?.city}
                          </p>
                          <div className="review-sec">
                            <span className="fa fa-star checked"></span>
                            <span className="fa fa-star checked"></span>
                            <span className="fa fa-star checked"></span>
                            <span className="fa fa-star checked"></span>
                            <span className="fa fa-star checked"></span>
                            <span className="reviews yelpuser-review" style={{ cursor: "pointer" }} data-toggle="modal" data-target="#myModal-review" data-id="X8ZS-dgiMIJvhwf9SaDnjw">
                              ({ele?.review_count})
                            </span>
                          </div>
                        </div>
                        <a href={ele.url} target="_blank" rel="noreferrer" className="siti-btn">{ele.categories[0]?.title.slice(0, 10)}</a>
                        </a>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              ):(`Oops! No Data Available ${`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}`)}           
            </div>

          </div>
          : <DataLoader />
      }

    </Fragment>
  );
}

export default FamilyAttraction;
